/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{useLexicalComposerContext as e}from"@lexical/react/LexicalComposerContext";import{useLayoutEffect as t,useEffect as n,useMemo as i,useState as r,useRef as o}from"react";const u="undefined"!=typeof window&&void 0!==window.document&&void 0!==window.document.createElement?t:n;function c(e){return{initialValueFn:()=>e.isEditable(),subscribe:t=>e.registerEditableListener(t)}}function a(){return function(t){const[n]=e(),c=i((()=>t(n)),[n,t]),[a,l]=r((()=>c.initialValueFn())),d=o(a);return u((()=>{const{initialValueFn:e,subscribe:t}=c,n=e();return d.current!==n&&(d.current=n,l(n)),t((e=>{d.current=e,l(e)}))}),[c,t]),a}(c)}export{a as default,a as useLexicalEditable};
